var React = require('react');

function ProfileSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0C4.47773 0 0 4.47685 0 9.99956C0 15.5223 4.47729 19.9991 10 19.9991C15.5231 19.9991 20 15.5223 20 9.99956C20 4.47685 15.5231 0 10 0ZM10 2.98998C11.8273 2.98998 13.308 4.47114 13.308 6.29755C13.308 8.1244 11.8273 9.60511 10 9.60511C8.17359 9.60511 6.69288 8.1244 6.69288 6.29755C6.69288 4.47114 8.17359 2.98998 10 2.98998ZM9.9978 17.3847C8.17535 17.3847 6.50619 16.721 5.21875 15.6224C4.90512 15.3549 4.72415 14.9627 4.72415 14.5511C4.72415 12.6988 6.22332 11.2163 8.07608 11.2163H11.9248C13.778 11.2163 15.2715 12.6988 15.2715 14.5511C15.2715 14.9631 15.0914 15.3545 14.7773 15.622C13.4903 16.721 11.8207 17.3847 9.9978 17.3847Z","fill":"white"}));
}

ProfileSvg.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ProfileSvg;

ProfileSvg.default = ProfileSvg;
